export const dateMask = "DD/MM/YYYY";
export const dateMaskRaw = "YYYY-MM-DD";
